import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Immutable from 'immutable';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';

import css from './PublicLayoutDesktop.module.scss';
// import PreviewToggleOld from '../components/Public/Floating/PreviewToggleOld';
import LogoAndHeadingContainer from '../containers/Public/LogoAndHeadingContainer';
import Navbar from '../components/Public/DesktopNavbar/Navbar';
import Footer from '../containers/Public/Footer/FooterContainer';
import SponsorsTicker from '../components/Public/SponsorsTicker/SponsorsTicker';
import HeaderDesktop from '../components/Public/Header/HeaderDesktop';
import JWFooter from '../components/Public/JWFooter/JWFooter';
import JWSubscriptionWidget from '../components/Public/JWSubscriptionWidget/JWSubscriptionWidget';
import { homePath } from '../lib/constants/links';
import PreviewToggleOld from 'appDir/components/Public/Floating/PreviewToggleOld';
import { WebsiteNotActive } from './usePublicLayoutDisabled';

const styles = {
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  footer: {
    flexShrink: 0,
  },
};

const onHomepage = location => location.pathname === homePath;

const PublicLayoutDesktop = ({
  children,
  classes,
  canEditOrganization,
  isEditingOrganization,
  $$organization,
  organizationBackgroundImage,
  isUserSignedIn,
  $$navbarItems,
  viewDisabled,
}) => {
  return (
    <div className={classes.content}>
      <HeaderDesktop
        canEditOrganization={canEditOrganization}
        isUserSignedIn={isUserSignedIn}
        isEditingOrganization={isEditingOrganization}
        navbarItems={$$navbarItems}
        orgLogoFilename={$$organization.get('logo_filename')}
      />
      <div
        className={css.mainDesktop}
        style={{ backgroundImage: `url(${organizationBackgroundImage})` }}
      >
        {/*<div className={css.mainDesktop}>*/}
        {canEditOrganization && <PreviewToggleOld />}
        <Grid container className={css.container}>
          {!onHomepage(location) && isEditingOrganization && (
            <div style={{ position: 'absolute', top: 15, left: 15, zIndex: 4 }}>
              <Button variant="contained" href={homePath}>
                Return To Homepage
              </Button>
            </div>
          )}
          <Grid item xs={12}>
            <JWSubscriptionWidget
              organization={$$organization}
              canEditOrganization={canEditOrganization}
            />
          </Grid>
          <Grid item xs={12}>
            <LogoAndHeadingContainer />
          </Grid>
          {!viewDisabled && (
            <Grid item xs={12}>
              <header>
                <Navbar
                  isEditingOrganization={isEditingOrganization}
                  navbarItems={$$navbarItems}
                />
              </header>
            </Grid>
          )}
          {viewDisabled ? <WebsiteNotActive /> : children}
        </Grid>
      </div>
      <div className={classes.footer}>
        {!viewDisabled && (
          <React.Fragment>
            {onHomepage(location) && (
              <SponsorsTicker isEditingOrganization={isEditingOrganization} />
            )}
            <Footer />
          </React.Fragment>
        )}
        <JWFooter organization={$$organization} />
      </div>
    </div>
  );
};

PublicLayoutDesktop.propTypes = {
  $$organization: PropTypes.instanceOf(Immutable.Map),
  $$sponsors: PropTypes.instanceOf(Immutable.List),
  $$navbarItems: PropTypes.instanceOf(Immutable.List),
  canEditOrganization: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  children: PropTypes.object.isRequired,
  isEditingOrganization: PropTypes.bool,
  isPreviewingWebsite: PropTypes.bool.isRequired,
  $$currentUser: PropTypes.object,
  homepage: PropTypes.bool,
};
PublicLayoutDesktop.defaultProps = {
  $$currentUser: Immutable.Map(),
  $$organization: Immutable.Map(),
  homepage: false,
};

export default withRouter(withStyles(styles)(PublicLayoutDesktop));
